var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.781,
    height: 13.002,
    viewBox: "0 0 18.781 13.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-mail",
    "data-name": "Icon ionic-ios-mail",
    transform: "translate(-3.375 -7.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_45811",
    "data-name": "Pfad 45811",
    d: "M22,10.342,17.145,15.29a.087.087,0,0,0,0,.126l3.4,3.621a.586.586,0,0,1,0,.831.589.589,0,0,1-.831,0L16.328,16.26a.093.093,0,0,0-.131,0l-.826.84a3.635,3.635,0,0,1-2.591,1.093,3.708,3.708,0,0,1-2.646-1.124l-.795-.808a.093.093,0,0,0-.131,0L5.822,19.868a.589.589,0,0,1-.831,0,.586.586,0,0,1,0-.831l3.4-3.621a.1.1,0,0,0,0-.126L3.529,10.342a.089.089,0,0,0-.154.063v9.9A1.449,1.449,0,0,0,4.82,21.75H20.712a1.449,1.449,0,0,0,1.445-1.445V10.4A.09.09,0,0,0,22,10.342Z",
    transform: "translate(0 -0.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_45812",
    "data-name": "Pfad 45812",
    d: "M13.07,16.141a2.454,2.454,0,0,0,1.765-.74l7.084-7.21a1.419,1.419,0,0,0-.894-.316H5.12a1.41,1.41,0,0,0-.894.316l7.084,7.21A2.455,2.455,0,0,0,13.07,16.141Z",
    transform: "translate(-0.304 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEMail);
export default __webpack_public_path__ + "static/media/Icon-EMail.5addc0ff822e3c82ad998a1ad6bae6a1.svg";
export { ForwardRef as ReactComponent };